import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexColumn, FlexRow } from "@similarweb/ui-components";

export const GAContainer = styled.div`
    width: 100%;

    & .contentWithShadow {
        box-shadow: 0 3px 6px 0 rgba(14, 30, 62, 0.08);
    }
`;

export const WidgetsContainer = styled(FlexColumn)`
    width: 100%;
    background: ${colorsPalettes.carbon[0]};
    position: relative;
    border-radius: 6px;
`;

export const ConnectGAContainer = styled(FlexRow)`
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    position: absolute;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, #f5f8ff 100%);
    border-radius: 6px;
`;

const ConnectGAText = styled.p`
    margin: 0 8px;
    ${setFontVariant("subtitle2", colorsPalettes.carbon[400])}
`;

export const CarouselWrapper = styled.div`
    width: 100%;
    box-sizing: border-box;

    .carouselItemWrapper {
        width: 100%;
    }
    [class*="CarouselButtonLeft"],
    [class*="CarouselButtonRight"] {
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.3s ease;
    }

    &:hover {
        [class*="CarouselButtonLeft"],
        [class*="CarouselButtonRight"] {
            opacity: 1;
            pointer-events: auto;
        }
    }
    [class*="CarouselButtonLeft"] {
        left: 5px;
    }
    [class*="CarouselButtonRight"] {
        right: 5px;
    }
`;
